<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2022-02-10 23:16:15
 * @LastEditTime: 2022-10-16 23:24:50
 * @LastEditors: chenguobiao
-->
<template>
  <div></div>
</template>

<script>
import store from 'store'
import { USER_INFO } from '@/config/const'
import { homeAPI } from '@/apis'
export default {
  name: 'Index',
  created() {
    this.getLoginSource()
  },
  methods: {
    async getLoginSource() {
      const { data: userType } = await homeAPI.postLoginJudgeSource({
        domain: window.top.location.host,
      })
      this.$store.commit('auth/setUserType', userType)
      if (userType === '0') {
        this.$router.replace('/login')
      } else {
        if (this.$route.query.code) {
          const { code, data } = await homeAPI.postLoginByCode({
            code: this.$route.query.code,
            userType,
          })
          if (code === 10003) {
            this.$router.replace('/collection?uid=' + data)
          } else if (code === 10004) {
            this.$message.error(data)
            setTimeout(() => {
              history.back()
            }, 1500)
          } else {
            this.$store.commit('auth/setToken', data.token)
            store.set(USER_INFO, data)
            setTimeout(() => {
              this.$router.push('/home')
            })
          }
        } else {
          history.back()
        }
      }
    },
  },
}
</script>

<style>
</style>
